import type { FC, ReactNode } from 'react'

import { useEffect, useState } from 'react'
import { cn } from '@/lib/utils'
import { nowInWIB } from '@/lib/dates'

// Rendered only after mount: the server and the first client render show the same placeholder.
export const LiveClock: FC<{ className?: string }> = ({ className }): ReactNode => {
    const [now, setNow] = useState<{ date: string, time: string } | null>(null)

    useEffect(() => {
        const tick = (): void => setNow(nowInWIB())

        tick()
        const timer = window.setInterval(tick, 1000)

        return () => window.clearInterval(timer)
    }, [])

    return (
        <div className={cn('min-w-36 flex-col items-end leading-tight', className)}>
            <span className='text-[11px] font-medium text-muted-foreground'>
                {now?.date ?? 'Memuat tanggal'}
            </span>

            <span className='font-mono text-[13px] font-semibold text-foreground tabular-nums'>
                {now ? `${now.time} WIB` : '--.--.-- WIB'}
            </span>
        </div>
    )
}
